import {
    makeInitialState,
    type ManualImportFormState,
} from '@/pages/purchases/manualImport/manualImportMeta';
import type { AnalysisResult } from '@/pages/purchases/components/excelImport/excelImportMeta';

/**
 * Seed the manual-import form state from an Excel analysis: the elected
 * supplier + the clean lines. Branch, invoice number and date stay empty —
 * they're not template columns and are chosen on this confirmation page.
 */
export const makeFileImportDraft = (
    result: AnalysisResult,
): ManualImportFormState => ({
    ...makeInitialState(),
    supplierId: result.supplierId,
    lines: result.lines,
});
